/**
 * 用户登录（与 web/src/api/login.js 一致）
 */
import { saveToken } from '../utils/auth.js';
import { getApiUrl } from '../config/api.js';

export async function login(username, password) {
  const res = await fetch(getApiUrl('login'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password })
  });
  const json = await res.json();
  if (json.code === 200 && json.data) {
    saveToken(json.data.token);
    return { success: true, data: json.data };
  }
  return {
    success: false,
    message: json.message || '登录失败'
  };
}
